/** Shared CRM contact sheet layout tokens (create + detail). */
export const CONTACT_CRM_SHEET_CLASS =
  "flex h-full max-h-dvh w-full max-w-md flex-col gap-0 overflow-hidden border-s border-border/60 bg-surface p-0 text-foreground shadow-lg";

export const contactSheetHeaderClass =
  "flex shrink-0 items-start justify-between gap-3 border-b border-border/60 bg-surface px-4 py-3";

export const contactSheetHeaderIconClass =
  "mt-0.5 inline-grid size-8 shrink-0 place-items-center rounded-lg border border-accent/15 bg-accent/8 text-accent";

export const contactSheetTitleClass =
  "text-start text-[0.9375rem] font-semibold tracking-[-0.01em] text-foreground";

export const contactSheetDescriptionClass = "text-start text-[0.75rem] leading-snug text-muted";

export const contactSheetBodyClass = "min-h-0 flex-1 overflow-y-auto px-4 py-3.5";

export const contactSheetSectionClass = "grid gap-2.5";

export const contactSheetSectionLegendClass =
  "m-0 text-[0.6875rem] font-semibold tracking-[0.04em] text-ink-subtle uppercase";

export const contactFormFieldLabelClass = "text-[0.75rem] font-medium text-foreground";

export const contactFormFieldInputClass =
  "h-9 w-full rounded-lg border border-border bg-background px-2.5 text-[0.8125rem] text-foreground shadow-none transition-[border-color,box-shadow] placeholder:text-muted focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[color-mix(in_srgb,var(--color-accent)_55%,transparent)] disabled:cursor-not-allowed disabled:opacity-70";

export const contactFormTwoColClass = "grid gap-2.5 sm:grid-cols-2";

export const contactSheetFooterClass = "shrink-0 border-t border-border/60 bg-surface px-4 py-3";

export const contactViewFieldLabelClass = "text-[0.6875rem] font-medium text-muted";

export const contactViewFieldValueClass = "min-w-0 text-[0.8125rem] leading-snug text-foreground";

export const contactViewSectionClass = "border-t border-border/40 py-3 first:border-t-0 first:pt-0";

export const contactViewSectionIconClass =
  "inline-grid size-5 shrink-0 place-items-center rounded-md bg-accent/10 text-accent";

export const contactIdentityHeaderClass = "flex flex-wrap items-start justify-between gap-2 pb-3";

export const contactIdentityAvatarClass =
  "inline-grid size-9 shrink-0 place-items-center rounded-full border border-accent/15 bg-accent/10 text-[0.75rem] font-semibold tracking-wide text-accent";
